import { Injectable } from '@angular/core';

/**
 * Übergibt eine im Onboarding-Wizard-Step gewählte CSV-Datei an die Ziel-Seite
 * (Kontakte/Ressourcen). Der Step wählt die Datei per Nutzergeste (File-Picker
 * im Auswahl-Dialog), navigiert zur Seite, und deren Tabelle holt die Datei hier
 * ab und startet den bestehenden Import-Flow. So bleibt die getestete
 * Import-Logik in der Tabelle, ohne sie zu duplizieren.
 */
@Injectable({ providedIn: 'root' })
export class PendingCsvImportService {
  private readonly files = new Map<string, File>();

  set(entity: string, file: File): void {
    this.files.set(entity, file);
  }

  /** Datei einmalig abholen (danach entfernt → Import startet nur beim ersten Laden). */
  take(entity: string): File | undefined {
    const file = this.files.get(entity);
    this.files.delete(entity);
    return file;
  }
}
